import React, { memo, useEffect, useState } from 'react'
import { Header, Container } from 'semantic-ui-react'
import { Review } from './Review'
import { DiagnosticsForm, initialValues } from './Form'
import { post } from './api'
import sourceBusinessUnits from './data/sourceBusinessUnits.json'
import { TEST_ENVIRONMENT } from './environment'
import { formLabels } from './labels'

const { title } = formLabels
const styles = {
  container: {
    marginBottom: '2em'
  }
}
const FormHeader = memo(props => {
  return (
    <Container text textAlign='center' style={styles.container}>
      <Header as={'h2'} textAlign='center'>
        {title}
      </Header>
    </Container>
  )
})

const initialFormState = {
  submitted: false,
  submitting: false,
  posted: false,
  posting: false,
  error: false,
  values: initialValues
}

const inferSBU = parentHref => {
  const embeddedTestSite = parentHref.startsWith('PROVIDER*')
  if (embeddedTestSite) {
    return parentHref.split('*')[1]
  } else {
    const sourceBusinessUnitSearch = Object.entries(sourceBusinessUnits).filter(
      ([sbu, _]) => parentHref.includes(sbu)
    )
    if (!sourceBusinessUnitSearch.length) {
      console.warn('Unable to infer the SBU!')
    }
    return sourceBusinessUnitSearch.length
      ? sourceBusinessUnitSearch[0][1]
      : 'South Coast Radiology (QLD)' // take the value of the first result
  }
}

const FormBody = memo(props => {
  const { parentHref } = props
  const sourceBusinessUnit = inferSBU(parentHref)
  const [formState, setFormState] = useState(initialFormState)

  const handleReset = () => setFormState(initialFormState)
  const handlePost = async () => {
    try {
      setFormState(state => ({
        ...state,
        posting: true
      }))
      const result = await post(formState.values, sourceBusinessUnit)
      setFormState(state => ({
        ...state,
        posted: true,
        posting: false,
        error: false
      }))
    } catch (error) {
      console.error('Error posting data:', error)
      setFormState(state => ({
        ...state,
        posted: false,
        posting: false,
        error: true
      }))
    }
  }

  return !formState.submitted ? (
    <DiagnosticsForm {...{ formState, setFormState, sourceBusinessUnit }} />
  ) : (
    <Review
      {...{
        formState,
        setFormState,
        handleReset,
        handlePost,
        sourceBusinessUnit
      }}
    />
  )
})

const App = () => {
  // get alternate parent location from query string
  const urlParams = new URLSearchParams(window.location.search)
  const queryParentHref = urlParams.get('parentHref')

  const [parentHref, setParentHref] = useState(
    queryParentHref
      ? queryParentHref
      : TEST_ENVIRONMENT
      ? 'https://www.scr.com.au/pacs-transfer-test/'
      : null
  )
  const MAX_TRIES = 100

  const ready = parentHref !== null

  useEffect(() => {
    let tries = 0
    const interval = setInterval(() => {
      if (window.spc_parent_location) {
        setParentHref(window.spc_parent_location)
        clearInterval(interval)
      } else if (tries >= MAX_TRIES) {
        clearInterval(interval)
        // todo: show problem message
      }
      tries += 1
    }, 200)
  }, [])

  return (
    <>
      <FormHeader />
      {ready && <FormBody {...{ parentHref }} />}
      <div style={{
        fontSize: '0.8em',  
        textAlign: 'center',
        color: '#888'
      }}>
        Powered by Virtual Blue
      </div>
    </>
  )
}

export default App
